import JobCostingStore from "./JobCosting.Store";
import { RootStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const jobCostingRoute: RouteType = {
  name: "Job Costing",
  path: "/accounting/job-costing",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Job Costing",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./JobCosting.Header"),
    },
    body: {
      component: () => import("./JobCosting.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const jobCostingStore = rootStore.jobCostingViewStore as JobCostingStore;
    await Promise.all([
      jobCostingStore.loadJobs(),
      jobCostingStore.loadCostAllocations(),
    ]);
    return true;
  },
  dialogs: [
    {
      name: "createJob",
      title: "Create Job",
      component: () => import("./dialogs/CreateJobDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const jobCostingStore =
          rootStore.jobCostingViewStore as JobCostingStore;
        await jobCostingStore.saveJob();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const jobCostingStore =
          rootStore.jobCostingViewStore as JobCostingStore;
        const formData = jobCostingStore.formData;
        return !formData.jobNumber || !formData.jobName;
      },
      cancelButton: true,
      height: 650,
    },
    {
      name: "jobDetails",
      title: "Job Details",
      component: () => import("./dialogs/JobDetailsDialog.Body"),
      cancelButton: true,
      height: 700,
    },
    {
      name: "allocateCost",
      title: "Allocate Cost",
      component: () => import("./dialogs/AllocateCostDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const jobCostingStore =
          rootStore.jobCostingViewStore as JobCostingStore;
        await jobCostingStore.saveCostAllocation();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const jobCostingStore =
          rootStore.jobCostingViewStore as JobCostingStore;
        const cost = jobCostingStore.costAllocationFormData;
        return !cost.jobId || !cost.category || !cost.totalCost;
      },
      cancelButton: true,
      height: 550,
    },
  ],
};

export default jobCostingRoute;
